import { setup } from "bem-cn";

const block = setup({
  el: "__",
  mod: "--",
  modValue: "-"
});

export function mod(modifiers: Object, prefixedModifiers: Object = {}) {
  const result = {};

  Object.keys(modifiers).forEach(key => {
    if (modifiers[key]) {
      result[modifiers[key]] = true;
    }
  });

  return { ...result, ...prefixedModifiers };
}

export default block;
